import React                        from 'react';
import { goldThickness }            from 'pu-data/SelectOptions';
import { goldThickness as tooltip } from 'pu-data/Tooltips';
import SelectComponent              from './SelectComponent';

const GoldThickness = (props) => {
  const name = 'gold_thickness';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <SelectComponent
      label={props.label}
      required={props.required}
      name={name}
      onChange={onChange}
      options={props.options}
      tooltip={props.tooltip}
      selected={props.parameters[name]}
      groupName={props.groupName} />
  );
};

GoldThickness.defaultProps = {
  options: goldThickness,
  label  : 'Gold<br class="d-none d-lg-block" /> Thickness',
  tooltip,
};

export default GoldThickness;
